import { OPERATOR } from "../types/logic.ts";

export const UNSELECTABLE_FIELD_KINDS = [
    "ai_statement",
    "statement",
    "section",
    "redirection",
    "welcome_screen",
    "end_screen",
];

export const TEXT_OPERATORS = [
    {
        value: OPERATOR.EQUAL,
        label: "Equals",
    },
    {
        value: OPERATOR.NOT_EQUAL,
        label: "Does not equal",
    },
    {
        value: OPERATOR.CONTAINS,
        label: "Contains",
    },
    {
        value: OPERATOR.NOT_CONTAINS,
        label: "Does not contain",
    },
    {
        value: OPERATOR.STARTS_WITH,
        label: "Starts with",
    },
    {
        value: OPERATOR.ENDS_WITH,
        label: "Ends with",
    },
    {
        value: OPERATOR.EXISTS,
        label: "Exists",
    },
    {
        value: OPERATOR.NOT_EXISTS,
        label: "Does not exist",
    },
    {
        value: OPERATOR.REGEX,
        label: "Regex",
    },
];

export const SINGLE_CHOICE_OPERATORS = [
    {
        value: OPERATOR.EQUAL,
        label: "Equals",
    },
    {
        value: OPERATOR.NOT_EQUAL,
        label: "Does not equal",
    },
];

export const MULTIPLE_CHOICE_OPERATORS = [
    {
        value: OPERATOR.EQUAL,
        label: "Equals",
    },
    {
        value: OPERATOR.NOT_EQUAL,
        label: "Does not equal",
    },
];

export const NUMBER_OPERATORS = [
    {
        value: OPERATOR.EQUAL,
        label: "Equals",
    },
    {
        value: OPERATOR.NOT_EQUAL,
        label: "Does not equal",
    },
    {
        value: OPERATOR.GREATER_THAN,
        label: "Greater than",
    },
    {
        value: OPERATOR.LESS_THAN,
        label: "Less than",
    },
    {
        value: OPERATOR.GREATER_THAN_OR_EQUAL,
        label: "Greater than or equal to",
    },
    {
        value: OPERATOR.LESS_THAN_OR_EQUAL,
        label: "Less than or equal to",
    },
];

export const MAP_OPERATOR_TO_FIELD_KIND = {
    short_text: TEXT_OPERATORS,
    multiple_choice: SINGLE_CHOICE_OPERATORS || MULTIPLE_CHOICE_OPERATORS,
    dropdown: SINGLE_CHOICE_OPERATORS,
    file_upload: SINGLE_CHOICE_OPERATORS,
    email: TEXT_OPERATORS,
    phone_number: TEXT_OPERATORS,
    legal: SINGLE_CHOICE_OPERATORS,
    country: SINGLE_CHOICE_OPERATORS,
    rating: NUMBER_OPERATORS,
    picture_choice: SINGLE_CHOICE_OPERATORS || MULTIPLE_CHOICE_OPERATORS,
};
